import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { Location, BaseLocation } from '../../../../../core/interfaces/location';
import { TranslocoPipe } from '@jsverse/transloco';
import { CustomButtonComponent } from "../../../../../shared/components/custom-button/custom-button.component";
import { LocationService } from '../../../../../core/api/location.service';
import { firstValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiErrorService } from '../../../../../core/api/api-error.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-delete-location-dialog',
  standalone: true,
  imports: [FormsModule, DialogModule, TranslocoPipe, CustomButtonComponent, CommonModule],
  templateUrl: './delete-location-dialog.component.html',
  styleUrl: './delete-location-dialog.component.css'
})
export class DeleteLocationDialogComponent {
  visible: boolean = false;
  location?: Location;

  deleteClicked = false;

  @Input() reloadLocationsCallbackFunction!: () => void;

  // Dialog error
  dialogErrorMessage: string | null = null;

  constructor(private locationService: LocationService, private apiError: ApiErrorService) { }

  openModal(location: Location): void {
    this.visible = true;

    this.location = location;
    this.deleteClicked = false;
    this.dialogErrorMessage = null;
  }

  closeModal(): void {
    this.visible = false;
  }

  async deleteLocation() {
    if (this.deleteClicked) {
      return;
    }
    this.deleteClicked = true;


    // Send request for creating location
    try {
      await firstValueFrom(this.locationService.deleteLocation(this.location!.id));
    } catch (error) {
      var crid = 'UNKNOWN-CRID';
      if (error instanceof HttpErrorResponse) {
        crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
      }
      this.dialogErrorMessage = `${await this.apiError.getErrorHeader()} ${await this.apiError.getErrorMessage(crid)}`;
      this.deleteClicked = false;
      return;
    }

    this.deleteClicked = false;
    this.closeModal();
    if (this.reloadLocationsCallbackFunction) {
      this.reloadLocationsCallbackFunction();
    }

  }
}
